module.exports = __webpack_public_path__ + "img/ic_teacher_wenben.03b72b80.png";